// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-checkbox {
  width: 17.1875rem;
}
.dropdown-checkbox-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  background-color: rgba(var(--grey-100));
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  height: 2.5rem;
  padding: 0.5rem;
}
.dropdown-checkbox-header-title {
  font-size: 0.875rem;
  line-height: 1.57;
  font-weight: 500;
  color: rgba(var(--grey-800));
  transition: all 0.3s ease-in-out;
  width: 100%;
}
.dropdown-checkbox-header-icon {
  transition: transform 0.5s;
}
.dropdown-checkbox-header-icon_open {
  transform: rotateX(180deg);
  transition: transform 0.5s;
}
.dropdown-checkbox-list {
  overflow-y: auto;
  opacity: 1;
  max-height: 304px;
  transition: all 1s;
}
.dropdown-checkbox-list_hidden {
  opacity: 0;
  transition: all 0.5s cubic-bezier(0, 1, 0, 1);
  max-height: 0px;
}
.dropdown-checkbox-list_hidden .dropdown-checkbox-list-item {
  overflow: hidden;
}
.dropdown-checkbox-list-item {
  font-size: 0.875rem;
  line-height: 1.57;
  color: rgba(var(--grey-800));
  transition: all 0.5s cubic-bezier(0, 1, 0, 1);
  padding: 0.5rem;
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.dropdown_mobile .dropdown-checkbox {
  width: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/DropdownCheckbox/styles.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,uCAAA;EACA,gCAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AACJ;AACI;EACE,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;EACA,gCAAA;EACA,WAAA;AACN;AAEI;EACE,0BAAA;AAAN;AAEM;EACE,0BAAA;EACA,0BAAA;AAAR;AAKE;EACE,gBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AAHJ;AAKI;EACE,UAAA;EACA,6CAAA;EACA,eAAA;AAHN;AAKM;EACE,gBAAA;AAHR;AAOI;EACE,mBAAA;EACA,iBAAA;EACA,4BAAA;EACA,6CAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AALN;;AAWE;EACE,WAAA;AARJ","sourcesContent":[".dropdown-checkbox {\n  width: 17.1875rem;\n\n  &-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    box-sizing: border-box;\n    background-color: rgba(var(--grey-100));\n    transition: all 0.3s ease-in-out;\n    cursor: pointer;\n    height: 2.5rem;\n    padding: 0.5rem;\n\n    &-title {\n      font-size: 0.875rem;\n      line-height: 1.57;\n      font-weight: 500;\n      color: rgba(var(--grey-800));\n      transition: all 0.3s ease-in-out;\n      width: 100%;\n    }\n\n    &-icon {\n      transition: transform 0.5s;\n\n      &_open {\n        transform: rotateX(180deg);\n        transition: transform 0.5s;\n      }\n    }\n  }\n\n  &-list {\n    overflow-y: auto;\n    opacity: 1;\n    max-height: 304px;\n    transition: all 1s;\n\n    &_hidden {\n      opacity: 0;\n      transition: all 0.5s cubic-bezier(0, 1, 0, 1);\n      max-height: 0px;\n\n      .dropdown-checkbox-list-item {\n        overflow: hidden;\n      }\n    }\n\n    &-item {\n      font-size: 0.875rem;\n      line-height: 1.57;\n      color: rgba(var(--grey-800));\n      transition: all 0.5s cubic-bezier(0, 1, 0, 1);\n      padding: 0.5rem;\n      margin-top: 0.5rem;\n      display: flex;\n      align-items: center;\n      cursor: pointer;\n    }\n  }\n}\n\n.dropdown_mobile {\n  .dropdown-checkbox {\n    width: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
